<template>
  <div>
    <!-- 原材料  -->
    <div>
      <el-button plain size="small" type="primary" @click="clickImport">导入</el-button>
      <el-button plain size="small" type="danger" @click="clickDel">删除</el-button>
      <!--<el-button size="small" type="success" @click="importOther">导入其他样品数据</el-button>-->
    </div>
    <el-table :data="qutaForm.quta_mtrl_list" border class="vg_mt_16" style="width: 100%" @selection-change="selectChange">
      <el-table-column align="center" type="selection"></el-table-column>
      <el-table-column align="center" label="序号" type="index"></el-table-column>
      <el-table-column align="center" label="物料编号" min-width="120" prop="mtrl_no">
        <template slot-scope="scope">
          <el-form-item
            :prop="'quta_mtrl_list.' + scope.$index + '.mtrl_no'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-input
              v-model.trim="qutaForm.quta_mtrl_list[scope.$index].mtrl_no"
              clearable
              disabled
              maxlength="30"
              show-word-limit
              size="small"
            ></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="物料类型" min-width="100" prop="mtrl_type">
        <template slot-scope="scope">
          <el-form-item
            :prop="'quta_mtrl_list.' + scope.$index + '.mtrl_type'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-select v-model="qutaForm.quta_mtrl_list[scope.$index].mtrl_type" disabled size="small">
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="物料名称" min-width="120" prop="mtrl_name">
        <template slot-scope="scope">
          <el-form-item
            :prop="'quta_mtrl_list.' + scope.$index + '.mtrl_name'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-tooltip :content="scope.row.mtrl_name" class="item" effect="dark" placement="top-start">
              <el-input
                v-model.trim="qutaForm.quta_mtrl_list[scope.$index].mtrl_name"
                clearable
                disabled
                maxlength="30"
                show-word-limit
                size="small"
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="物料规格" min-width="120" prop="mtrl_spec">
        <template slot="header">
          <span style="color: red">物料规格</span>
        </template>
        <template slot-scope="scope">
          <el-form-item
            :prop="'quta_mtrl_list.' + scope.$index + '.mtrl_spec'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-tooltip :content="scope.row.mtrl_spec" class="item" effect="dark" placement="top-start">
              <el-input
                v-model="qutaForm.quta_mtrl_list[scope.$index].mtrl_spec"
                :autosize="{ minRows: 1, maxRows: 4 }"
                clearable
                maxlength="50"
                show-word-limit
                size="small"
                type="textarea"
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="部位" min-width="150" prop="quta_mtrl_part">
        <template #header>
          <span style="color: red">部位</span>
        </template>
        <el-table-column align="center" min-width="120">
          <template #header>
            <el-button-group>
              <el-button size="mini" @click="setColor(0)">黑色</el-button>
              <el-button size="mini" type="danger" @click="setColor(1)">红色</el-button>
            </el-button-group>
          </template>
          <template v-slot="scope">
            <el-form-item
              :prop="'quta_mtrl_list.' + scope.$index + '.quta_mtrl_part'"
              :rules="{ required: true, message: ' ', trigger: 'blur' }"
              label-width="0"
            >
              <el-tooltip :content="scope.row.quta_mtrl_part" effect="dark" placement="top-start">
                <el-input
                  v-model="qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_part"
                  :autosize="{ minRows: 1, maxRows: 4 }"
                  :class="qutaForm.quta_mtrl_list[scope.$index].is_red === 1 ? 'quta' : ''"
                  clearable
                  maxlength="50"
                  show-word-limit
                  size="small"
                  type="textarea"
                  @focus="e => setColorIndex(e, scope.$index)"
                />
              </el-tooltip>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column align="center" label="用量" min-width="140" prop="quta_mtrl_consume">
        <template slot="header">
          <span style="color: red">用量</span>
        </template>
        <template slot-scope="scope">
          <el-form-item
            :prop="'quta_mtrl_list.' + scope.$index + '.quta_mtrl_consume'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-input
              v-model="qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_consume"
              maxlength="15"
              show-word-limit
              size="small"
              @blur="
                qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_consume = helper.calcPrice(
                  qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_consume,
                  4,
                  10000000000
                )
              "
              @change="() => getTotalPrice(999)"
              @input="
                qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_consume =
                  qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_consume
                    .replace(/^0+(\d)/, '$1')
                    .replace(/^\./, '0.')
                    .match(/^\d*(\.?\d{0,4})/g)[0] || ''
              "
            >
            </el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="损耗比率" min-width="140" prop="quta_mtrl_lossrate">
        <template slot="header">
          <span style="color: red">损耗比率</span>
        </template>
        <template slot-scope="scope">
          <el-form-item
            :prop="'quta_mtrl_list.' + scope.$index + '.quta_mtrl_lossrate'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-input
              v-model="qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_lossrate"
              maxlength="15"
              show-word-limit
              size="small"
              @blur="
                qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_lossrate = helper.calcPrice(
                  qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_lossrate,
                  4,
                  10000000000
                )
              "
              @change="() => getTotalPrice(999)"
              @input="
                qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_lossrate =
                  qutaForm.quta_mtrl_list[scope.$index].quta_mtrl_lossrate
                    .replace(/^0+(\d)/, '$1')
                    .replace(/^\./, '0.')
                    .match(/^\d*(\.?\d{0,4})/g)[0] || ''
              "
            >
            </el-input>
          </el-form-item>
        </template>
      </el-table-column>

      <el-table-column align="center" label="含损耗用量" min-width="140" prop="quta_contain_lossrate">
        <template slot="header">
          <span style="color: red">含损耗用量</span>
        </template>
        <template slot-scope="scope">
          <el-form-item
            :prop="'quta_mtrl_list.' + scope.$index + '.quta_contain_lossrate'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-input
              v-model="qutaForm.quta_mtrl_list[scope.$index].quta_contain_lossrate"
              disabled
              maxlength="15"
              show-word-limit
              size="small"
            >
            </el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <!--      <el-table-column label="单价" align="center" prop="mtrl_price" min-width="140">-->
      <!--        <template slot="header">-->
      <!--          <span style="color: red">单价</span>-->
      <!--        </template>-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-form-item-->
      <!--            :prop="'quta_mtrl_list.' + scope.$index + '.mtrl_price'"-->
      <!--            label-width="0"-->
      <!--            :rules="{ required: true, message: ' ', trigger: 'blur' }"-->
      <!--          >-->
      <!--            <el-input-->
      <!--              size="small"-->
      <!--              v-model="qutaForm.quta_mtrl_list[scope.$index].mtrl_price"-->
      <!--              maxlength="15"-->
      <!--              show-word-limit-->
      <!--              @change="getTotalPrice"-->
      <!--              @input="-->
      <!--                qutaForm.quta_mtrl_list[scope.$index].mtrl_price =-->
      <!--                  qutaForm.quta_mtrl_list[scope.$index].mtrl_price-->
      <!--                    .replace(/^0+(\d)/, '$1')-->
      <!--                    .replace(/^\./, '0.')-->
      <!--                    .match(/^\d*(\.?\d{0,4})/g)[0] || ''-->
      <!--              "-->
      <!--              @blur="-->
      <!--                qutaForm.quta_mtrl_list[scope.$index].mtrl_price = helper.calcPrice(-->
      <!--                  qutaForm.quta_mtrl_list[scope.$index].mtrl_price,-->
      <!--                  4,-->
      <!--                  10000000000-->
      <!--                )-->
      <!--              "-->
      <!--            >-->
      <!--            </el-input>-->
      <!--          </el-form-item>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column align="center" label="总价" min-width="140" prop="sum_money"></el-table-column>
      <el-table-column align="center" label="价格明细" min-width="140" show-overflow-tooltip>
        <template slot="header">
          <span style="color: red">价格明细</span>
        </template>
        <template slot-scope="scope">
          <!-- <el-form-item label-width="0">
            <el-input v-model="qutaForm.quta_mtrl_list[scope.$index].mtrl_addcost" disabled size="small"></el-input>
          </el-form-item> -->
          <el-form-item label-width="0">
            <el-row>
              <el-col :md="12"><span>复合费用</span></el-col>
              <el-col :md="12">
                <el-input
                  v-model="qutaForm.quta_mtrl_list[scope.$index].mtrl_comp_addcost"
                  placeholder="暂无复合费用"
                  maxlength="7"
                  show-word-limit
                  @change="getTotalPrice"
                  @input="val => onBomInput2('mtrl_comp_addcost', val, scope.$index)"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label-width="0">
            <el-row>
              <el-col :md="12"><span>印花费用</span></el-col>
              <el-col :md="12">
                <el-input
                  v-model="qutaForm.quta_mtrl_list[scope.$index].mtrl_prit_addcost"
                  placeholder="暂无印花费用"
                  maxlength="7"
                  show-word-limit
                  @change="getTotalPrice"
                  @input="val => onBomInput2('mtrl_prit_addcost', val, scope.$index)"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item v-for="(value, key, index) in safeParseMtrbBom(scope.row)" :key="key + index" label-width="0">
            <el-row>
              <el-col :md="12"
                ><el-tooltip :content="key" effect="dark" placement="top-start">
                    <span style="white-space: nowrap; overflow: hidden; display: block">{{ key }}</span>
                  </el-tooltip></el-col
              >
              <el-col :md="12">
                <el-input
                  v-model="qutaForm.quta_mtrl_list[scope.$index].mtrb_bom_mater[key]"
                  :placeholder="`暂无${key}费用`"
                  maxlength="7"
                  show-word-limit
                  @change="getTotalPrice"
                  @input="val => onBomInput(val, scope.$index, key)"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="right" label="金额" min-width="120" prop="dyjsum_money" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-form-item :prop="'quta_mtrl_list.' + scope.$index + '.dyjsum_money'" label-width="0">
            <el-input
              v-model="qutaForm.quta_mtrl_list[scope.$index].dyjsum_money"
              :value="(scope.row.dyjsum_money = calcDyjSumMoney(scope.row))"
              disabled
              size="small"
            >
            </el-input>
          </el-form-item>
        </template>
      </el-table-column>
    </el-table>

    <div class="vd_price_toatl">
      <div class="vd_price">
        <h3><span>总计:</span></h3>
        <h2 class="vg_ml_8" style="color: #c70e0e">
          <span>{{ totalPrice }}</span>
        </h2>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" title="提示" width="70%">
      <requImport :qutaForm="qutaForm" @childChange="childChange" />
    </el-dialog>
    <el-dialog :visible.sync="smplListVisible" title="导入样品报价单" width="70%">
      <SmplListImport ref="SmplEditIn" :qutaForm="qutaForm" @childSmpl="childSmpl"></SmplListImport>
    </el-dialog>
  </div>
</template>

<script>
import requImport from './requImport2.vue';
import { BigNumber } from 'bignumber.js';
import SmplListImport from './SmplListImport.vue';
import { formatNumberOver100 } from '@assets/js/regExUtil';

export default {
  name: 'QutaRawMater',
  components: {
    requImport,
    SmplListImport
  },
  props: {
    qutaForm: {
      type: Object,
      required: true,
      default() {
        return {
          quta_mtrl_list: []
        };
      }
    }
  },
  data() {
    return {
      mulTab: [],
      total: 0,
      dialogVisible: false,
      typeList: [
        { value: 0, label: '原面料' },
        { value: 3, label: '加工面料' }
      ],
      colorIndex: 0,
      totalPrice: 0,
      smplListVisible: false
    };
  },
  created() {
    this.initData();
  },
  methods: {
    formatNumberOver100,
    initData() {},
    // mtrb_bom_mater 输入处理：格式化值 + 触发重算
    onBomInput(val, index, key) {
      this.qutaForm.quta_mtrl_list[index].mtrb_bom_mater[key] = formatNumberOver100(val);
      this.getTotalPrice();
    },
    // 复合/印花费用输入处理：格式化值 + 触发重算
    onBomInput2(field, val, index) {
      this.qutaForm.quta_mtrl_list[index][field] = formatNumberOver100(val);
      this.getTotalPrice();
    },
    // 安全解析 mtrb_bom_mater，兼容字符串和对象两种形态
    safeParseMtrbBom(row) {
      if (!row.mtrb_bom_mater) return {};
      if (typeof row.mtrb_bom_mater === 'string') {
        try {
          const parsed = JSON.parse(row.mtrb_bom_mater || '{}');
          this.$set(row, 'mtrb_bom_mater', parsed);
          return parsed;
        } catch (e) {
          this.$set(row, 'mtrb_bom_mater', {});
          return {};
        }
      }
      return row.mtrb_bom_mater;
    },
    selectChange(selection) {
      this.mulTab = selection;
    },
    clickImport() {
      this.dialogVisible = true;
    },
    clickDel() {
      if (this.mulTab.length === 0) {
        return this.$message.warning('至少选择一条数据');
      }
      let temp = [];
      for (let i = 0; i < this.mulTab.length; i++) {
        let ind = null;
        ind = this.qutaForm.quta_mtrl_list.indexOf(this.mulTab[i]);
        temp.push(ind);
      }
      temp = temp.sort((a, b) => {
        return b - a;
      });
      for (let j of temp) {
        this.qutaForm.quta_mtrl_list.splice(j, 1);
      }
      this.getTotalPrice();
    },
    childChange(selection) {
      selection.forEach(item => {
        item.mtrl_price = this.helper.haveFour(item.mtrl_prod_price, 4);
        this.$set(item, 'quta_mtrl_part', ''); //部位
        this.$set(item, 'quta_contain_lossrate', '');
        this.$set(item, 'quta_mtrl_lossrate', item.smpl_mtrl_loss); //损耗百分比
        this.$set(item, 'quta_mtrl_consume', this.helper.haveFour(item.smpl_mtrl_consume, 4)); //用量
        this.$set(item, 'mtrl_addcost', item.smpl_mtrl_addcost); //额外费用
        this.$set(item, 'mtrl_prit_addcost', item.smpl_prit_addcost); //额外费用
        this.$set(item, 'mtrl_comp_addcost', item.smpl_comp_addcost); //额外费用
        item.sum_money = 0;
        this.qutaForm.quta_mtrl_list.push(item);
      });
      this.dialogVisible = false;
    },
    getTotalPrice(flag) {
      // 计算含损耗用量
      if (flag === 999) {
        this.qutaForm.quta_mtrl_list.forEach(item => {
          item.quta_contain_lossrate = this.helper.haveFour(item.quta_mtrl_lossrate * item.quta_mtrl_consume);
        });
      }
      // 计算金额（含复合费、印花费、价格明细） × 含损耗率
      let num = new BigNumber(0);
      if (this.qutaForm.quta_mtrl_list) {
        this.qutaForm.quta_mtrl_list.forEach(item => {
          // 累加 mtrb_bom_mater 中的价格明细
          let bomTotal = new BigNumber(0);
          if (item.mtrb_bom_mater && typeof item.mtrb_bom_mater === 'object') {
            for (const key in item.mtrb_bom_mater) {
              bomTotal = bomTotal.plus(Number(item.mtrb_bom_mater[key]) || 0);
            }
          }
          // 设置总价列 = 复合费用 + 印花费用 + 价格明细之和
          item.sum_money = this.helper.haveFour(
            new BigNumber(item.mtrl_comp_addcost || 0)
              .plus(item.mtrl_prit_addcost || 0)
              .plus(bomTotal)
              .toNumber(),
            4
          );
          // 计算金额
          let num1 = new BigNumber(0);
          num1 = num1
            .plus(item.mtrl_comp_addcost)
            .plus(item.mtrl_prit_addcost)
            // .plus(item.mtrl_price)
            .plus(bomTotal);
          num1 = num1.times(item.quta_contain_lossrate).toNumber();
          let num2 = this.helper.haveFour(num1);
          num = num.plus(num2);
        });
      }
      num = num.toNumber();
      this.totalPrice = this.helper.haveFour(num, 4);
      this.$emit('getTotalPriceTo', num);
    },
    calcDyjSumMoney(row) {
      // 累加 mtrb_bom_mater 中的价格明细
      let bomTotal = new BigNumber(0);
      if (row.mtrb_bom_mater && typeof row.mtrb_bom_mater === 'object') {
        for (const key in row.mtrb_bom_mater) {
          bomTotal = bomTotal.plus(Number(row.mtrb_bom_mater[key]) || 0);
        }
      }
      return this.helper.haveFour(
        new BigNumber(row.mtrl_prit_addcost)
          .plus(row.mtrl_comp_addcost)
          // .plus(row.mtrl_price)
          .plus(bomTotal)
          .times(row.quta_contain_lossrate)
          .toNumber()
      );
    },
    setColor(val) {
      this.qutaForm.quta_mtrl_list[this.colorIndex].is_red = val;
    },
    setColorIndex(e, index) {
      this.colorIndex = index;
    },
    importOther() {
      this.smplListVisible = true;
    },
    // 导入smpllist传值
    childSmpl(val, checkList) {
      this.$confirm('此操作将覆盖此报价单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.confirmSmplList(val, checkList);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消覆盖!'
          });
        });
    },
    confirmSmplList(val, checkList) {
      //原材料 新增
      if (checkList.find(item => item === '原材料')) {
        val.quta_mtrl_list.forEach(item => {
          item.quta_mtrl_id = null;
          item.quta_id = null;
          this.qutaForm.quta_mtrl_list.push(item);
        });
        this.getTotalPrice(999);
      }

      //辅助材料 覆盖
      if (checkList.find(item => item === '辅助材料')) {
        val.quta_accmtrl_list.forEach(item => {
          item.quta_mtrl_id = null;
          item.quta_id = null;
        });
        this.qutaForm.quta_accmtrl_list = val.quta_accmtrl_list;
        this.$emit('importCompute');
      }
      //人工工资 覆盖
      if (checkList.find(item => item === '人工工资')) {
        this.qutaForm.quta_sala_maps = val.quta_sala_maps;
        this.$emit('importCompute');
      }
      //配件信息
      if (checkList.find(item => item === '配件信息')) {
        this.qutaForm.quta_part_list = val.quta_part_list;
        this.$emit('importCompute');
      }
      this.smplListVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .quta {
  .el-textarea__inner {
    color: red;
  }
}

.vd_price_toatl {
  /* display: flex;
  justify-content: space-between; */
  padding: 10px 20px;
}

.vd_price {
  display: flex;
  justify-content: flex-end;
}
</style>
